import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { subsShiftingCheck, qryOfferForShifting, subsShifting } from '@/pages/Shift/services';
import { qrySubsMemDetail } from '@/services/business';

import { getRequestData, failAlert } from '@/utils';

const defaultState = {
  step: 0, // 移机业务流程的步骤
  searchCustInfo: {}, // 从搜索页面同步过来的用户信息
  serviceType: {}, // 从搜索页面同步过来的服务类型
  subServiceType: {}, // 从搜索页面同步过来的子服务类型
  comboUnitNbrFlagList: [], // combo子套餐手机号是否必填列表
  canNumUse: true, // 手机号是否可用 默认是 true
  canPlanUse: true, // 套餐是否可用 默认是 true
};

export default {
  namespace: 'shift',
  state: cloneDeep(defaultState),
  effects: {
    *subsShiftingCheck({ payload }, { call, put, select }) {
      const response = yield call(subsShiftingCheck, payload);
      const result = getRequestData(response, false);
      const { offerFlag, accNbrFlag, acctFlag, shiftingFlag, comboUnitAccNbrFlagDtoList = [], returnCode, returnMsg } = result;
      if (`${returnCode}` !== '0') {
        // 提示后端check内容
        failAlert({ title: '', content: returnMsg });
      }
      const isCombo = !isEmpty(comboUnitAccNbrFlagDtoList);
      const params = {
        canShifting: shiftingFlag === 'Y',
        canNumUse: accNbrFlag === 'Y',
        canPlanUse: offerFlag === 'Y',
        canAcctUse: acctFlag === 'Y',
        isCombo,
      };
      let comboUnitNbrFlagList = comboUnitAccNbrFlagDtoList;
      if (!isEmpty(comboUnitAccNbrFlagDtoList)) {
        // 查询主订户套餐详情，并组装数据
        const custId = yield select(state => state.shift.custId);
        const mainSubsDetail = yield call(qrySubsMemDetail, { custId, subsId: payload.subsId });
        const { subsDto = {} } = getRequestData(mainSubsDetail, false);
        comboUnitNbrFlagList = comboUnitNbrFlagList.map(combo => {
          const comboDetail = (get(subsDto, 'subsMemberDtoList') || []).find(it => `${combo.subsId}` === `${it.subsId}`) || {};
          return {
            ...combo,
            comboDetail,
          };
        });
      }
      yield put({
        type: 'save',
        payload: {
          ...params,
          comboUnitNbrFlagList,
        },
      });
      return { ...params, returnMsg };
    },
    //  移机可选套餐查询
    *qryOfferForShifting({ payload }, { call, select }) {
      const { selectSubsInfo, transferAddress } = yield select(state => state.shift);
      const params = {
        subsId: selectSubsInfo.subsId,
        installationAddressId: transferAddress.selectAddress,
        offerName: payload.offerName,
        pageDto: {
          pageIndex: get(payload, 'pageInfo.currentPage') || 1,
          pageCount: get(payload, 'pageInfo.pageSize') || 7,
        },
      };
      const response = yield call(qryOfferForShifting, params);
      const { availableOfferDtoList, pageDto } = getRequestData(response, false);
      return {
        offerList: availableOfferDtoList || [],
        pageDto: {
          currentPage: get(pageDto, 'pageIndex'),
          pageSize: get(pageDto, 'pageCount'),
          total: get(pageDto, 'totalRecord') || 0,
        },
      };
    },
    // 移机
    *subsShifting({ payload }, { call }) {
      const response = yield call(subsShifting, payload);
      const result = getRequestData(response, false);
      return result;
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clear() {
      return cloneDeep(defaultState);
    },
  },
};
